export const assistancesKo = [
  { id: '1', value: '아니요' },
  { id: '13', value: '아니요, 하지만 도움이 필요합니다(Door-to-Door)' },
  { id: '4', value: '휠체어(이동 불가)' },
  { id: '15', value: '휠체어(이동 가능)' },
  { id: '3', value: '보행기' },
  { id: '6', value: '거니 (환자 이송용 바퀴 달린 들것) 또는 스트래쳐 (들것) 이 필요합니다.' },
  { id: '9', value: 'Mileage Reimbursement' },
];
